import PropTypes from "prop-types";

import Card from "../Card";
import DynamicGroupField from "../Form/DynamicGroupField";
import { isValidEmail } from "../../helpers";

import "./adminAddUserCard.scss";

const AdminAddUserCard = ({ title, id }) => {
  const requiredFieldMessage = "Required field";

  return (
    <div className="admin-add-user">
      <Card title={title} id={id} openByDefault={true}>
        <div className="card__content">
          <DynamicGroupField
            title="Invite Advisors"
            fieldArrayName="usersData"
            store="adminAddUsers"
            inputFields={[
              {
                name: "fname",
                label: "First Name",
                options: {
                  placeholder: "Enter First Name",
                  required: requiredFieldMessage,
                  setValueAs: (v) => (v.trim().length > 0 ? v : ""),
                },
              },
              {
                name: "lname",
                label: "Last Name",
                options: {
                  placeholder: "Enter Last Name",
                  required: requiredFieldMessage,
                  setValueAs: (v) => (v.trim().length > 0 ? v : ""),
                },
              },
              {
                name: "email",
                label: "Email",
                options: {
                  placeholder: "Enter Email",
                  required: requiredFieldMessage,
                  setValueAs: (v) => (v.trim().length > 0 ? v : ""),
                  validate: (e) => isValidEmail(e) || "Invalid Email Address",
                },
              },
            ]}
          />
        </div>
      </Card>
    </div>
  );
};

AdminAddUserCard.propTypes = {
  title: PropTypes.string,
  id: PropTypes.string,
};

export default AdminAddUserCard;
